const Fedds=[
    {
        id:1,
        name: "Hamburger",
        price: "200",
        image: "images/burger.jpeg",
        quantity:1,
    },
    {
        id:2,
        name: "Fries",
        price: "100",
        image: "images/fries.jpeg",
        quantity:1,
    },
    {
        id:3,
        name: "Coke",
        price: "50",
        image: "images/coke.jpeg",
        quantity:1,
    },
    {
        id:4,
        name: "Pepsi",
        price: "50",
        image: "images/pepsi.jpeg",
        quantity:1,
    }
]
export default Fedds